<template>
  <section id="faq" class="faq">
    <div class="container">
      <h2>常见问题</h2>
      <div class="list">
        <details>
          <summary>是否支持 Managed Google Play 私有分发？</summary>
          <p>支持。可创建私有应用、内测通道与受管配置，并按组织单位精准推送。</p>
        </details>
        <details>
          <summary>支持哪些平台与设备？</summary>
          <p>原生支持 Apple watchOS 与 Google Wear OS，覆盖主流品牌与芯片。</p>
        </details>
        <details>
          <summary>数据合规与隐私如何保障？</summary>
          <p>遵循 GDPR/CCPA 等法规，提供数据脱敏、最小化与可审计能力。</p>
        </details>
        <details>
          <summary>是否支持 Play Integrity 与设备校验？</summary>
          <p>商业/企业版集成 Play Integrity API，可按需启用设备/账号完整性校验。</p>
        </details>
        <details>
          <summary>是否提供 SLA 与技术支持？</summary>
          <p>企业版提供 99.9% SLA、7×24 支持与专属技术顾问。</p>
        </details>
        <details>
          <summary>如何申请删除个人数据？</summary>
          <p>可在应用内提交删除请求，或发送邮件至 jiahengljin@gmail.com，我们将在 30 天内处理。</p>
        </details>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FAQ'
}
</script>

<style scoped>
.faq {
  padding: 64px 16px;
  background: #0f172a;
  color: #e5e7eb;
}
.container {
  max-width: 900px;
  margin: 0 auto;
}
details {
  background: #111827;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 10px;
}
summary {
  cursor: pointer;
}
</style>


